import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getBaseDocRule,
  getParticularPage,
  getNext,
  getPrevious,
  createBaseDocRule,
  updateBaseDocRule,
  handleSearch,
  getBaseDocRuleById,
} from "./thunk";

const initialState = {
  baseDocRules: [],
  edit: false,
  baseDocRule: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBaseDocRule: false,
  loadingNext: false,
  showCreateModal: false,
};

export const baseDocRuleSlice = createSlice({
  name: "baseDocRule",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllBaseDocRule: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBaseDocRule = false;
      state.baseDocRule = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBaseDocRule.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBaseDocRule.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createBaseDocRule.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getBaseDocRuleById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBaseDocRuleById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.baseDocRule = action.payload.data;
    });
    builder.addCase(getBaseDocRuleById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.baseDocRule = null;
    });
    builder.addCase(updateBaseDocRule.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBaseDocRule.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateBaseDocRule.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getBaseDocRule.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingBaseDocRule = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBaseDocRule.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBaseDocRule = false;
        state.baseDocRules = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBaseDocRule.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBaseDocRule = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllBaseDocRule } = baseDocRuleSlice.actions;

export default baseDocRuleSlice.reducer;
